module.exports = __webpack_public_path__ + "static/media/certificados_capital.9742b892.svg";